import { connect } from "react-redux";

import { FullFormState } from "../../../../../Engine/Core/Store/FullFormState";
import { CandyDispatch } from "../../../../../Engine/Core/Store/CandyReduxTypes";

import { closeCustomErrorLogTooltipAction } from "./CustomErrorLogTooltipAction";
import { CustomErrorLogTooltip } from "./CustomErrorLogTooltip";

const mapStateToProps = (state: FullFormState) => ({
    show: state.customErrorLogTooltip != undefined,
    anchorElement: state.customErrorLogTooltip?.anchorElement,
    render: () => state.customErrorLogTooltip?.message ?? "",
    isTargetEdited: false,
});

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    onCloseTooltip: () => dispatch(closeCustomErrorLogTooltipAction()),
});

export const CustomErrorLogTooltipContainer = connect(mapStateToProps, mapDispatchToProps)(CustomErrorLogTooltip);
